/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PointMesureDto } from '../../models/point-mesure-dto';

export interface GetPointsMesuresByEquipement$Params {
  /**
   * Id equipement
   */
  idEquipement: string;
}

export function getPointsMesuresByEquipement(
  http: HttpClient,
  rootUrl: string,
  params: GetPointsMesuresByEquipement$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<PointMesureDto>>> {
  const rb = new RequestBuilder(rootUrl, getPointsMesuresByEquipement.PATH, 'get');
  if (params) {
    rb.path('idEquipement', params.idEquipement, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PointMesureDto>>;
    })
  );
}

getPointsMesuresByEquipement.PATH = '/v1/points-mesures/byEquipement/{idEquipement}';
